/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable camelcase */
import { Box, Container, Stack } from '@mui/material';
import { memo } from 'react';
import PositiveButton from 'components/cmn/PositiveButton';
import useInspection from 'hooks/useInspection';
import {
  IClassificationProps,
  IInspectionDetail3Info2Props,
  IInspectionResult2InfoProps,
  IInspectionResult3InfoProps,
} from 'interface/inspection/InspectionInfo';

function ClassificationGuide3End(): JSX.Element {
  const {
    changeClassification,
    changeDetailProgressInfo,
    inspectionDetail,
    initInspectionEndClassification,
    // inspectionDetail3Info2, // 제거됨 - 새로 만들 예정
    // inspectionResult2Info, // 제거됨 - 새로 만들 예정
    // inspectionResult3Info, // 제거됨 - 새로 만들 예정
    // changeInspectionFinalStandard, // 제거됨 - 새로 만들 예정
  } = useInspection();

  // TODO: 새로 만들 예정 - 임시로 빈 객체 사용
  const inspectionDetail3Info2: any = {};
  const inspectionResult2Info: any = {};
  const inspectionResult3Info: any = {};
  const handleNextClassification = async () => {
    // inspectionEndClassification 초기화: 2차 분류와 3차 분류를 합친 최종 결과 생성
    await initInspectionEndClassification();
    await changeClassification('final');
    await changeDetailProgressInfo(0);
  };
  const sortedInspectionResult = () => {
    // TODO: 새로 만들 예정
    const testArray: any[] = [];

    // Object.keys(inspectionDetail3Info2).forEach(key => {
    //   const detailItems = inspectionDetail3Info2[key as keyof IInspectionDetail3Info2Props];
    //   ...
    // });

    return testArray;
  };
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        py: 4,
      }}
    >
      <Box
        sx={{
          p: 4,
          width: '100%',
          maxWidth: { xs: '100%', md: '1536px' },
          height: { xs: 'auto', md: '864px' },
        }}
      >
        <Container maxWidth="xl" sx={{ height: 'calc(100%)' }}>
          <Container maxWidth="lg" sx={{ p: 0, height: 'calc(100% - 84px)' }}>
            <Stack
              direction="column"
              justifyContent="center"
              alignContent="center"
              alignItems="center"
              sx={{ height: '100%' }}
            >
              <Box
                sx={{
                  fontSize: { xs: '19px', sm: '48px', md: '52px' },
                  fontWeight: 900,
                  textAlign: 'center',
                }}
              >
                3단계 분류가 종료되었습니다.
              </Box>
              <Box sx={{ height: 20 }} />
              <Box
                sx={{
                  fontSize: { xs: '19px', sm: '48px', md: '52px' },
                  fontWeight: 900,
                  textAlign: 'center',
                }}
              >
                다음단계로 진행합니다.
              </Box>
            </Stack>
          </Container>
        </Container>
      </Box>
      {/* 하단 버튼 영역 높이만큼 여백 추가 (버튼 높이 52px + 패딩 32px = 약 84px) */}
      <Box sx={{ height: { xs: 84, sm: 84 } }} />
      <Box
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          width: '100%',
          bgcolor: 'background.paper',
          boxShadow: '0px -2px 10px rgba(0, 0, 0, 0.1)',
          py: 2,
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <PositiveButton
          variant="contained"
          onClick={handleNextClassification}
          sx={{ width: { xs: 130 }, height: 52, typography: 's14w500' }}
          title="다음"
        />
      </Box>
    </Box>
  );
}

export default memo(ClassificationGuide3End);
